<app-form-field [formGroup]="parentFormGroup"
                [class.disabled]="!coreMeasured"
                class="form-field"
                [size]="computedSize"
                [sizeXl]="sizeXl"
                [sizeLg]="sizeLg"
                *ngIf="formDefinitionFieldModel"
                [hidden]="!formDefinitionFieldModel.summary.active"
                [required]="formDefinitionFieldModel.required"
                [label]="displayType === 'compact' ? undefined : (label ? label : formDefinitionFieldModel.summary.shortLabel)">
    <!-- {{parentFormGroup.get('ruleValue')?.value}} -->
    <ng-container title-actions *ngIf="displayType === 'default'">
        <div class="d-flex align-items-center">
            <span *ngIf="!coreMeasured" style="font-size: 0.7em;">Jugé satisfaisant</span>
            <span *ngIf="coreMeasured === true && formDefinitionFieldModel.notMeasuredAvailable === true" style="font-size: 0.7em; text-decoration: underline; cursor: pointer;" (click)="coreMeasured = !coreMeasured; parentFormGroup.get('value').setValue(undefined); parentFormGroup.get('comment').setValue(undefined);">Ne pas mesurer</span>
            <app-button [iconName]="parentFormGroup.value.comment ? 'message-check' : 'message'" [tooltip]="parentFormGroup.value.comment" (clickEvent)="openCommentDialog()" [disabled]="!coreMeasured"></app-button>
        </div>
    </ng-container>
    <div class="d-flex align-items-center">
        <div class="flex-grow-1">
            <ng-container *ngIf="isCustom">
                <ng-container #custom></ng-container>
            </ng-container>
            <ng-container *ngIf="!isCustom">
                <ng-container *ngIf="formDefinitionFieldModel.summary.type.value === FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_TEXT">

                    <app-input-text #input
                                    [parentFormGroup]="parentFormGroup" *ngIf="!formDefinitionFieldModel.summary.subType"
                                    parentFormControlName="value"
                                    (focussedEvent)="focussed()">
                    </app-input-text>
                    <app-input-textarea *ngIf="formDefinitionFieldModel.summary.subType?.value === FormDefinitionFieldSubType.FORM_DEFINITION_FIELD_SUBTYPE_LONGTEXT"
                                        class="d-block" style="width: 100%; border: 1px solid rgb(230, 230, 230);"
                        rows="5" [parentFormGroup]="parentFormGroup" parentFormControlName="value"
                        (focussedEvent)="focussed()">
                    </app-input-textarea>
                </ng-container>
                <ng-container *ngIf="formDefinitionFieldModel.summary.type.value === FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_NUMERIC">
                    <app-number-input #input
                                      [required]="formDefinitionFieldModel.required"
                                      [parentFormGroup]="parentFormGroup"
                                      parentFormControlName="value"
                                      (valueChangedEvent)="valueChanged()"
                                      (focussedEvent)="focussed()"
                                      [unit]="formDefinitionFieldModel.unit"
                                      [decimalDigits]="formDefinitionFieldModel.decimalDigits"></app-number-input>
                </ng-container>

                <ng-container *ngIf="formDefinitionFieldModel.summary.type.value === FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_CHOICE">
                    <ng-container *ngIf="!formDefinitionFieldModel.summary.subType">
                        <app-select-filter-v2 #input *ngIf="!formDefinitionFieldModel.data || formDefinitionFieldModel.data.indexOf('buttons') === -1"
                                           [parentFormGroup]="parentFormGroup"
                                           parentFormControlName="value"
                                           [elements]="options"
                                           (focussedEvent)="focussed()"></app-select-filter-v2>
                        <ng-container *ngIf="formDefinitionFieldModel.data && formDefinitionFieldModel.data.indexOf('buttons') > -1">
                            <app-chips [items]="chipItems" [onlyOneSelection]="true" [disabled]="!coreMeasured" (selectedChangedEvent)="onChipSelected()" (focussedEvent)="coreMeasured = true"></app-chips>
                        </ng-container>
                    </ng-container>

                </ng-container>
                <ng-container *ngIf="formDefinitionFieldModel.summary.type.value === FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_YES_NO">
                    <app-yes-no-input #input radioButton (valueChangedEvent)="valueChanged()" (focussedEvent)="focussed()" [parentFormGroup]="parentFormGroup" parentFormControlName="value"></app-yes-no-input>
                </ng-container>
                <ng-container *ngIf="formDefinitionFieldModel.summary.type.value === FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_NEGATIVE_POSITIVE">
                    <app-yes-no-input (valueChangedEvent)="valueChanged()" yesLabel="Positif" noLabel="Négatif" #input radioButton (focussedEvent)="focussed()" [parentFormGroup]="parentFormGroup" parentFormControlName="value"></app-yes-no-input>
                </ng-container>
                <ng-container *ngIf="formDefinitionFieldModel.summary.type.value === FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_RICH_TEXT">
                    <app-rich-text-editor #input (contentChangeEvent)="valueChanged()" [parentFormGroup]="parentFormGroup" parentFormControlName="value"></app-rich-text-editor>
                </ng-container>
            </ng-container>
        </div>
        <ng-container *ngIf="displayType === 'compact'">
            <i-tabler [name]="parentFormGroup.value.comment ? 'message-check' : 'message'" class="icon-18 link m-x-4" (click)="openCommentDialog()" [matTooltip]="parentFormGroup.value.comment"></i-tabler>
            <i-tabler name="ruler-2-off" class="icon-18 link m-r-4" *ngIf="coreMeasured" (click)="coreMeasured = !coreMeasured"></i-tabler>
        </ng-container>
       <div>
            <ng-content select="[button]"></ng-content>
        </div>
    </div>
    </app-form-field>
